import { createAction } from '@reduxjs/toolkit'

export const mediaPlaybackStarted = createAction('MEDIA_PLAYBACK_STARTED')
export const mediaPlaybackStopped = createAction('MEDIA_PLAYBACK_STOPPED')

export const MEDIA_PLAYBACK_STARTED = mediaPlaybackStarted.type
export const MEDIA_PLAYBACK_STOPPED = mediaPlaybackStopped.type
